<template>
  <div class="forcenter">
    <div class="c-inner">
      <div class="c-txt">
        <h2 style="font-weight: bold;padding:4rem 0 2rem 0;">COE教练隐私政策</h2>
        <div class="t-items">
          <h3 class="tit">前言</h3>
          <p class="des">
            1.1 南京菁英荟萃网络科技有限公司一向庄严承诺保护使用菁英荟萃的产品和服务（以下统称“菁英荟萃服务”）之用户（以下统称“用户”或“您”）的隐私。您在使用菁英荟萃服务时，我们可能会收集和使用您的相关信息。<br>
            1.2 本《隐私政策》适用于我们提供的一切菁英荟萃服务。当您使用我们任何单项服务时，您同意接受本《隐私政策》以及我们在该单项服务中发出的特定隐私信息类政策条款（下列称“特定条款”）的保护，在此情况下特定条款与本政策条款同时对您产生效力。例如：使用菁英荟萃支付的用户，同时适用本《隐私政策》。如特定条款与本《隐私政策》条款存在同类条款的不一致约定，则在特定条款约束范围内应以特定条款为准。如我们提供的某一单项服务不适用本《隐私政策》的，该服务中会以适当方式明示排除适用本《隐私政策》。<br>
            1.3 请注意我们不时地会检查我们的政策，因此有关的措施会随之变化。我们恳请您定期光顾本页面，以确保对我们《隐私政策》最新版本始终保持了解。您使用或继续使用菁英荟萃服务，都表示您同意我们按照本《隐私政策》收集、使用、储存和分享您的信息。
          </p>
          <div style="font-size: 12px;margin: 10px 0">版本更新及生效时间：2021年12月01日</div>
          <p class="des">【如何联系我们】我们深知您的个人信息务必得到保护，因此提供专门渠道处理您的隐私诉求及问询。如果您对本隐私政策中描述的个人信息处理实践有任何疑问，请通过发送邮箱 hryun818@163.com 联系我们</p>
        </div>
        <div class="t-items">
          <h3 class="tit">目录</h3>
          <p class="des">
            一、我们可能收集的信息<br>
            二、我们如何收集和使用信息<br>
            三、我们可能分享、转让和披露的信息<br>
            四、我们如何保留、储存和保护信息<br>
            五、如何管理您的信息<br>
            六、第三方服务<br>
            七、通知和修订<br>
            八、如何联系我们<br>
          </p>
        </div>
        <div class="t-items">
          <h3 class="tit">一、我们可能收集的信息</h3>
          <h4 class="tit2">1、与个人身份无关的信息：</h4>
          <p class="des">
            当您使用COE教练，我们可能收集和汇总诸如用户的来源途径、访问顺序等信息，例如记录使用菁英荟萃服务的每个用户的来源途径、浏览器软件等。
          </p>
          <h4 class="tit2">2、有关个人身份的信息：</h4>
          <p class="des">
            当您使用COE教练时，我们可能收集和汇总或要求您提供有关个人身份的信息，例如个人电话号码；个人财产信息（交易记录、余额、优惠券、云币余额等）；个人上网记录和日志信息（包括网站浏览记录、课程使用记录、点击记录、操作日志等）；我们收集您的信息主要是为了您和其他用户能够更容易和更满意地使用菁英荟萃服务。菁英荟萃的目标是向所有的互联网用户提供安全、高效的服务平台。
          </p>
        </div>

        <div class="t-items">
          <h3 class="tit">二、我们如何收集和使用信息</h3>
          <h4 class="tit2">（一）我们将通过以下途径收集和获得您的信息：</h4>
          <p class="des">
            1、您提供的信息。例如：<br>
           （1） 您在注册COE教练的帐号或使用菁英荟萃服务时，向我们提供的信息；<br>
           （2） 您通过COE教练向其他方提供的共享信息，以及您使用菁英荟萃服务时所储存的信息。<br>
            2、其他方分享的您的信息。亦即其他方使用COE教练时所提供有关您的共享信息。<br>
            3、我们获取的您的信息。您在使用COE教练时，我们收集、汇总、记录的信息，例如日志信息、位置信息、设备信息等。<br>
          </p>
          <h4 class="tit2">（二）我们会出于以下目的，收集和使用您的信息：</h4>
          <p class="des">
            1、帮助您完成注册<br>
            为便于我们为您提供服务，您需要提供基本注册信息，例如手机号码、电子邮箱地址等，并创建您的用户名和密码。在部分单项服务中，如果您仅需使用浏览、搜索等基本服务，您不需要注册成为菁英荟萃用户及提供上述信息。<br>
            2、向您提供商品或服务<br>
           （1）在部分服务项目中，为便于向您交付商品或服务，您需提供收货人个人联系电话。如果您拒绝提供此类信息，我们将无法完成相关交付服务。如您通过COE教练为其他人订购商品或服务，您需要提供该实际订购人的前述信息。<br>
           （2）为展示您账户的订单信息，我们会收集您在使用COE教练过程中产生的订单信息用于向您展示及便于您对订单进行管理；<br>
           （3）当您与我们联系时，我们可能会保存您的通信/通话记录和内容或您留下的联系方式等信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。<br>
           （4）为确认交易状态及为您提供售后与争议解决服务，我们会通过您基于交易所选择的交易对象、支付机构等收集与交易进度相关的您的交易、支付，或将您的交易信息共享给上述服务提供者。<br>
            3、向您推送消息<br>
            向您发出通知。我们可能在必需时（例如当我们由于系统维护而暂停某一单项服务、变更、终止提供某一单项服务时）向您发出与服务有关的通知。<br>
            如您不希望继续接收我们推送的消息，您可要求我们停止推送，例如：根据短信退订指引要求我们停止发送推广短信，或在移动端设备中进行设置，不再接收我们推送的消息等；但我们依法律规定或单项服务的服务协议约定发送消息的情形除外。<br>
            4、为您提供安全保障<br>
            为确保您身份真实性、向您提供更好的安全保障，您可以向我们提供身份证明、面部特征等生物识别信息等个人敏感信息以完成实名认证。<br>
            除身份验证外，我们可能将您的信息用于客户服务、安全防范、诈骗监测、存档和备份等用途，确保我们向您提供的服务的安全性；我们可能使用或整合我们所收集的您的信息，以及我们的合作伙伴取得您授权或依据法律共享的信息，来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。<br>
            5、改进我们的服务<br>
            我们可能将通过某一项菁英荟萃服务所收集的信息，用于我们的其他服务。例如，在您使用某一项菁英荟萃服务时所收集的您的信息，可能在另一项菁英荟萃服务中用于向您提供特定内容或向您展示与您相关的、而非普遍推送的信息；我们可能让您参与有关菁英荟萃服务的调查，帮助我们改善现有服务或设计新服务；同时，我们可能将您的信息用于软件更新。<br>
            我们可能获取您的IMEI,MAC地址信息行为，用于监测APP使用过程中产生的奔溃及报错信息，以及手机机型等，从而更好地完善我们的APP，提升您的使用体验;<br>
            您了解并同意，在收集您的信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别您的身份，在此情况下我们有权使用已经去标识化的信息，对用户数据库进行分析并予以商业化的利用。<br>
            如果我们将您的信息用于本《隐私政策》中未载明的其他用途，会事先征求您同意。<br>
            6、征得授权同意的例外<br>
            根据相关法律法规规定，以下情形中收集您的信息无需征得您的授权同意：<br>
           （1）与国家安全、国防安全有关的；<br>
           （2）与公共安全、公共卫生、重大公共利益有关的；<br>
           （3）与犯罪侦查、起诉、审判和判决执行等有关的；<br>
           （4）出于维护信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；<br>
           （5）所收集的信息是您自行向社会公众公开的；<br>
           （6）从合法公开披露的信息中收集信息的，如合法的新闻报道、政府信息公开等渠道；<br>
           （7）根据您的要求签订合同所必需的；<br>
           （8）用于维护菁英荟萃服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；<br>
           （9）为合法的新闻报道所必需的；<br>
           （10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的信息进行去标识化处理的；<br>
           （11）法律法规规定的其他情形。
          </p>
        </div>
        <div class="t-items">
          <h3 class="tit">三、我们可能分享、转让或披露的信息</h3>
          <h4 class="tit2">（一）分享</h4>
          <p class="des">
            除以下情形外，未经您同意，我们不会与COE教练之外的任何第三方分享您的信息：<br>
            1、向您提供我们的服务。我们可能向合作伙伴及其他第三方分享您的信息，以实现您需要的核心功能或提供您需要的服务，例如：向物流服务商提供对应的订单信息；<br>
            2、维护和改善我们的服务。我们可能向合作伙伴及其他第三方分享您的信息，以帮助我们为您提供更有针对性、更完善的服务，例如：代表我们发出电子邮件或推送通知的通讯服务提供商等；<br>
            3、实现本《隐私政策》第二条“我们如何收集和使用信息”部分所述目的；<br>
            4、履行我们在本《隐私政策》或我们与您达成的其他协议中的义务和行使我们的权利；<br>
            5、向委托我们进行推广的合作伙伴等第三方共享，但我们仅会向这些委托方提供推广的覆盖面和有效性的信息，而不会提供可以识别您身份的信息，例如姓名电话号码或电子邮箱；或者我们将这些信息进行汇总，以便它不会识别您个人。比如我们可以告知该委托方有多少人看了他们的推广信息或在看到这些信息后购买了委托方的商品，或者向他们提供不能识别个人身份的统计信息，帮助他们了解其受众或顾客。<br>
            6、在法律法规允许的范围内，为了遵守法律、维护我们及我们的关联方或合作伙伴、您或其他菁英荟萃用户或社会公众利益、财产或安全免遭损害，比如为防止欺诈等违法活动和减少信用风险，我们可能与其他公司和组织交换信息。不过,这并不包括违反本《隐私政策》中所作的承诺而为获利目的出售、出租、共享或以其它方式披露的信息。<br>
            7、应您合法需求，协助处理您与他人的纠纷或争议；<br>
            8、根据与您签署的单项服务协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；<br>
            9、基于符合法律法规的社会公共利益而提供。<br>
            10、为更好的向您提供分享、推送等相关服务，我们可能向合作伙伴或其他第三方分享您的信息（如IMEI等个人信息）<br>
            我们仅会出于合法、正当、必要、特定、明确的目的共享您的信息。对我们与之共享信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本《隐私政策》以及其他任何相关的保密和安全措施来处理信息。
          </p>
          <h4 class="tit2">（二）转让</h4>
          <p class="des">
            1、随着我们业务的持续发展，我们有可能进行合并、收购、资产转让或类似的交易，而您的信息有可能作为此类交易的一部分而被转移。我们会要求新的持有您信息的公司、组织继续受本《隐私政策》的约束，否则,我们将要求该公司、组织重新向您征求授权同意。<br>
            2、在获得您的明确同意后，我们会向其他方转让您的信息。
          </p>
          <h4 class="tit2">（三）披露</h4>
          <p class="des">
            我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会披露您的信息：<br>
            1、根据您的需求，在您明确同意的披露方式下披露您所指定的信息；<br>
            2、根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您信息的情况下，我们可能会依据所要求的信息类型和披露方式披露您的信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求接收方必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。
          </p>
          <h4 class="tit2">（四）我们如何保留、储存和保护信息</h4>
          <p class="des">
            我们仅在本《隐私政策》所述目的所必需期间和法律法规要求的时限内保留您的信息。<br>
            我们在中华人民共和国境内运营中收集和产生的信息，存储在中国境内，以下情形除外：<br>
            1、法律法规有明确规定；<br>
            2、获得您的授权同意；<br>
            3、您使用的产品、服务涉及跨境，菁英荟萃需要向境外提供您的个人信息的。<br>
            针对以上情形，我们会确保依据本政策及国家法律法规要求对您的个人信息提供足够的保护。<br>
            我们将采取以下手段保护您的信息：<br>
          </p>
          <h4 class="tit2">（五）数据安全技术措施</h4>
          <p class="des">
            我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的信息遭到未经授权的访问使用、修改,避免数据的损坏或丢失。网络服务采取了多种加密技术，例如在某些服务中，我们将利用加密技术（例如SSL）来保护您的信息，采取加密技术对您的信息进行加密保存，并通过隔离技术进行隔离。<br>
            在信息使用时，例如信息展示、信息关联计算，我们会采用多种数据脱敏技术增强信息在使用中安全性。采用严格的数据访问权限控制和多重身份认证技术保护信息，避免数据被违规使用。<br>
          </p>
          <h4 class="tit2">（六）我们为保护信息采取的其他安全措施</h4>
          <p class="des">
            我们通过建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范信息的存储和使用。<br>
            我们通过信息接触者保密协议、监控和审计机制来对数据进行全面安全控制。<br>
            加强安全意识。我们还会举办安全和隐私保护培训课程，加强员工对于保护信息重要性的认识。<br>
          </p>
          <h4 class="tit2">（七）我们仅允许有必要知晓这些信息的菁英荟萃员工、合作伙伴访问您的信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您的信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与菁英荟萃的合作关系。</h4>
          <h4 class="tit2">（八）我们会采取一切合理可行的措施，确保未收集无关的信息。</h4>
          <h4 class="tit2">（九）互联网并非绝对安全的环境，而且电子邮件、即时通讯、社交软件或其他服务软件等与其他用户的交流方式无法确定是否完全加密，我们建议您使用此类工具时请使用复杂密码，并注意保护您的信息安全。</h4>
          <h4 class="tit2">（十）互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。</h4>
          <h4 class="tit2">（十一）安全事件处置</h4>
          <p class="des">
            在通过COE教练与第三方进行沟通或购买商品及服务时，您不可避免的要向交易对方或潜在的交易对方披露自己的信息，如联络方式或者邮政地址等。请您妥善保护自己的信息，仅在必要的情形下向他人提供。<br>
            为应对信息泄露、损毁和丢失等可能出现的风险，我们制定了多项制度，明确安全事件、安全漏洞的分类分级标准及相应的处理流程。我们也为安全事件建立了专门的应急响应团队，按照安全事件处置规范要求，针对不同安全事件启动安全预案，进行止损、分析、定位、制定补救措施、联合相关部门进行溯源和打击。<br>
            在不幸发生信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们同时将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报信息安全事件的处置情况。
          </p>
        </div>

        <div class="t-items">
          <h3 class="tit">五、如何管理您的信息</h3>
          <h4 class="tit2">（一）访问、更新和删除</h4>
          <p class="des">
            我们鼓励您更新和修改您的信息以使其更准确有效。您能通过COE教练访问您的信息，并根据对应信息的管理方式自行完成或要求我们进行修改、补充和删除。我们将采取适当的技术手段，尽可能保证您可以访问、更新和更正自己的信息或使用菁英荟萃服务时提供的其他信息。
          </p>
          <h4 class="tit2">（二）公开与分享</h4>
          <p class="des">
            我们的多项服务可让您不仅与您的社交网络、也与使用该服务的所有用户公开分享您的相关信息，例如，您在菁英荟萃服务中所上传或发布的信息、您对其他人上传或发布的信息作出的回应，通过电子邮件或在菁英荟萃服务中不特定用户可见的公开区域内上传或公布您的个人信息，以及包括与这些信息有关的位置数据和日志信息。只要您不删除您所公开或共享的信息，有关信息可能一直留存在公众领域；即使您删除共享信息，有关信息仍可能由其他用户或不受我们控制的第三方独立地缓存、复制或储存，或由其他用户或该等第三方在公众领域保存。如您将信息通过上述渠道公开或共享，由此造成您的信息泄露，我们不承担责任。因此，我们提醒并请您慎重考虑是否通过上述渠道公开或共享您的信息。
          </p>
          <h4 class="tit2">（三）注销</h4>
          <p class="des">
            在符合COE教练单项服务的服务协议约定条件及国家相关法律法规规定的情况下，您的该项COE教练服务帐号可能被注销或删除。当帐号注销或被删除后，与该帐号相关的、该单项服务项下的全部服务资料和数据将依照单项服务的服务协议约定删除或处理。
          </p>
          <h4 class="tit2">（四）改变您授权同意的范围</h4>
          <p class="des">
            您总是可以选择是否披露信息。有些信息是使用COE教练服务所必需的，但大多数其他信息的提供是由您决定的。您可以通过删除信息、关闭设备功能等方式改变您授权我们继续收集信息的范围或撤回您的授权。<br>
            当您撤回授权后，我们无法继续为您提供撤回授权所对应的服务，也不再处理您相应的信息。但您撤回授权的决定，不会影响此前基于您的授权而开展的信息处理。
          </p>
          <h4 class="tit2">（五）有关敏感信息的提示</h4>
          <p class="des">
            某些信息因其特殊性可能被认为是敏感信息，例如您的种族、宗教、个人健康和医疗信息等，以及身份证明文件、个人生物识别信息、财产信息、行踪轨迹、未成年人的信息等。<br>
            请注意，您在菁英荟萃服务中所提供、上传或发布的内容和信息（例如有关您社交活动的照片或信息），可能会泄露您的敏感信息。您需要谨慎地考虑，是否使用菁英荟萃服务披露您的敏感信息。<br>
            您同意您的敏感信息按本《隐私政策》所述的目的和方式来处理。
          </p>
        </div>
        <div class="t-items">
          <h3 class="tit">六、第三方服务</h3>
          <p class="des">
            COE教练服务可能链接至第三方提供的社交媒体或其他服务（包括网站或其他服务形式）。包括：<br>
            （1）您可利用“分享”键将某些内容分享到菁英荟萃服务，或您可利用第三方服务登录菁英荟萃服务。这些功能可能会收集您的信息（包括您的日志信息），并可能在您的电脑装置COOKIES，从而正常运行上述功能；<br>
            （2）我们通过广告或我们服务的其他方式向您提供链接，使您可以接入第三方的服务或网站；<br>
            （3）其他接入第三方服务的情形。<br>
            该等第三方社交媒体或其他服务由相关的第三方负责运营。您使用该等第三方的社交媒体服务或其他服务（包括您向该等第三方提供的任何信息），须受第三方自己的服务条款及信息保护声明（而非本《隐私政策》）约束，您需要仔细阅读其条款。本《隐私政策》仅适用于我们所收集的任何信息，并不适用于任何第三方提供的服务或第三方的信息使用规则，而我们对任何第三方使用由您提供的信息不承担任何责任。<br>
            COE教练关于集成第三方SDK的说明<br>
            （1）应用中集成了com.tencent.smtt(TBS腾讯浏览服务;腾讯浏览服务;腾讯X5浏览器;腾讯浏览器)仅限于方便用户浏览doc、pdf、txt、excel等文档文件；<br>
            接入TBS后会收集用户的哪些信息？<br>
            为实现各类腾讯浏览服务SDK的特定业务功能，我们可能需要向开发者和/或终端用户收集相关个人信息。以下将详细列出腾讯浏览服务SDK的各项业务功能及为实现该功能所收集的个人信息情况：<br>
            为了准确控制内核版本下发和开关下发，以及基于webview标准协议，我们需要获取用户的手机型号(设备IP)，从而保证服务的准确性、有效性。<br>
            为了便于用户搜索、分享已复制的内容，我们需要访问剪切板，读取其中包含的链接、内容，从而保证搜索、分享等功能的实现。<br>
            （2）应用中集成了com.alipay(支付宝;阿里乘车码;阿里芝麻信用实名认证;芝麻认证)仅用于用户购买HRCOE服务相关产品使用；<br>
            （3）应用中集成了com.tencent.bugly(Bugly;腾讯Bugly)，收集用户IMEI,MAC地址敏感信息行为，仅限于用于实时监测APP相关出错信息，了解用户机型以便于更好的优化APP，为用户提供更好的使用体验;<br>
            （4）应用中集成了com.tencent.tinker(Tinker;Tinker在线热修复;腾讯云Tinker)，用于紧急修复一些线上bug；<br>
            （5）应用中集成了com.umeng(友盟)，用于分享页面及其他一些推送服务（开营提示、互动提示等）；<br>
            （6）应用中集成了com.aliyun(阿里云;阿里push;阿里推送;)等SDK，用于视频播放及其他一些推送服务；<br>
            （7）应用中集成了【友盟+】消息推送服务（U-Push）<br>
            【友盟+】消息推送服务，基于全域数据建立的精准消息推送平台，为您提供更灵活、更智能、更有效的消息推送方案，有效提升用户粘性，提高App活跃度。产品集成友盟+SDK及推送通道SDK（如小米、华为、oppo、vivo、魅族等）,我们采集设备标识符(IMEI/Mac/android ID/IDFA/OPENUDID/GUID、SIM卡IMSI 信息)，用于唯一标识设备，以便向目标设备推送消息。采集地理位置甄别推送通道，提高消息推送的区域覆盖率。<br/>
            SDK名称：友盟消息推送SDK<br>
            SDK服务商：友盟同欣（北京）科技有限公司<br>
            收集个人信息类型：设备信息（IMEI/MAC/Android ID/IDFA/OAID/OpenUDID/GUID/SIM卡IMSI/ICCID）、位置信息、网络信息<br>
            隐私权政策链接：https://www.umeng.com/page/policy<br>
          </p>
        </div>
        <div class="t-items">
          <h3 class="tit">七、通知和修订</h3>
          <p class="des">
            我们可能适时修改本《隐私政策》的条款，该等修改构成本《隐私政策》的一部分。对于重大变更，我们会提供更显著的通知，您可以选择停止使用菁英荟萃服务；在该种情况下，如您仍然继续使用菁英荟萃服务的，即表示同意受经修订的本《隐私政策》的约束。<br>
            任何修改都会将您的满意度置于首位。我们鼓励您在每次使用菁英荟萃服务时都查阅我们的隐私政策。<br>
            我们可能在必需时（例如当我们由于系统维护而暂停某一项服务时）发出与服务有关的公告。您可能无法取消这些与服务有关、性质不属于推广的公告。<br>
            最后，您必须对您的账号和密码信息负有保密义务。任何情况下，请小心妥善保管。
          </p>
        </div>
        <div class="t-items">
          <h3 class="tit">八、如何联系我们</h3>
          <p class="des">开发者信息：南京菁英荟萃网络科技有限公司<br>
            开发者联系方式：13255926691<br>
            联系邮箱: hryun818@163.com
          </p>
          <p class="des">
            如您有关于网络信息安全的投诉和举报，或您对本《隐私政策》、您的信息的相关事宜有任何问题、意见或建议，以及有关本声明或COE教练的隐私措施的问题请在平台建议窗口输入您的建议，平台收到后会及时调整及修正。
          </p>
        </div>

        <div class="t-items">
          <h3 class="tit">九、账号注册、注销功能</h3>
          <p class="des">
            注册和登录功能需要您主动提供：手机号码、验证码，并创建密码。您的密码将以加密形式进行自动存储、传输、验证，我们不会以明文方式存储、传输、验证您的密码。是否修改昵称、头像不会影响注册及会员功能（如开通）的正常使用。
            提供的上述信息，将在您使用本服务期间持续授权我们使用。在您注销账号时，我们将停止使用并删除上述信息。上述信息将存储于中华人民共和国境内。如需跨境传输，我们将会单独征得您的授权同意，并根据法律规定依法跨境传输。
            账号注销相关信息及账号注销处理时效：立即生效，无法恢复账号。需谨慎账号注销;<br>
            账号注销渠道：您可以通过【登入app】-【点击我的】-【账号注销】-申请注销；
          </p>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {}
};
</script>
<style scoped>
.forcenter {
  width: 37.5rem;
  margin: 0 auto;
  background: #fff;
  padding-bottom: 3rem;
}

.c-inner {
  border: 1px solid #ccc;
  padding: 1.2rem;
  line-height: 180%;
}

.c-inner .des{
  font-size: 12px;
  line-height: 1.6rem;
}
.c-inner .c-txt h2 {
  font-size: 24px;
  text-align: center;
}

.c-inner .c-txt .t-items {
  padding: 10px 0;
}

.c-inner .tit {
  font-size: 14px;
  padding-bottom: 1rem;
  line-height: 1.6rem;
  font-weight: bold;
}
.c-inner .tit2 {
  font-size: 12px;
  padding-bottom: 0.5rem;
  line-height: 1.6rem;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// mainView.vue?4b60f9d2